import React from "react";
import "./TradePerformanceCentreAbout.css";

import AboutHero from "./AboutHero";
import AboutPositioning from "./AboutPositioning";
import AboutMethod from "./AboutMethod";
import TpcTrainerSpotlight from "./TpcTrainerSpotlight";
import TpcTrainerMarnusSpotlight from "./TpcTrainerMarnusSpotlight";
import TpcTrainerJacquesSpotlight from "./TpcTrainerJacquesSpotlight";

function TradePerformanceCentreAbout() {
  return (
    <main className="trpc-aboutPage" aria-labelledby="trpc-aboutHero-title">
      <AboutHero />
      <TpcTrainerSpotlight />
      <TpcTrainerMarnusSpotlight />
      <TpcTrainerJacquesSpotlight />
      <AboutPositioning />
      <AboutMethod />
    </main>
  );
}

export default TradePerformanceCentreAbout;